export default __webpack_public_path__ + "static/media/slide3.097ce2ef.png";